import styled from 'styled-components'

import { style } from 'theme'

const Body = styled.p`
  color: ${style(theme => theme.colors.slate)};
  font-size: 14px;
  font-weight: 400;
  line-height: 1.58;
  margin: 0;
`

export default Body
